import { Link } from '@material-ui/core';
import { Typography } from '@dev/ee-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { push } from 'redux-first-history';
import { SettingsPaths } from '@/services/dictionaries/Paths';
import { StaleContactLink } from './StaleContactLink';

export const StaleContactsAlertBody = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const redirectToTrackingAndPruning = (): void => {
        dispatch(push(SettingsPaths.TrackingAndPruning));
    };

    return (
        <Typography variant="body1">
            {t('stalesegmentdesc')} {<StaleContactLink />} {t('workinconjunctionwith')}{' '}
            <Link onClick={redirectToTrackingAndPruning}>{t('contactpruningsettings')}.</Link>
        </Typography>
    );
};
